module.exports = __webpack_public_path__ + "img/eg-2.8e5104f1.jpg";